type UploadAssetType = 'instruction' | 'drawing' | 'video';

interface BuildUploadFileParams {
  assetType: UploadAssetType;
  file: File;
  title?: string | null;
  vehicleModelId?: number | string | null;
  workstationId?: number | string | null;
}

const sanitizeSegment = (value: string) =>
  value
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .slice(0, 60);

const getFileExtension = (fileName: string) => {
  const extension = fileName.includes('.') ? fileName.split('.').pop() : '';
  return extension ? extension.toLowerCase() : 'bin';
};

const buildTimestamp = () => {
  const now = new Date();
  const yyyy = now.getFullYear();
  const mm = String(now.getMonth() + 1).padStart(2, '0');
  const dd = String(now.getDate()).padStart(2, '0');
  const hh = String(now.getHours()).padStart(2, '0');
  const min = String(now.getMinutes()).padStart(2, '0');
  const sec = String(now.getSeconds()).padStart(2, '0');
  return `${yyyy}${mm}${dd}-${hh}${min}${sec}`;
};

export const buildUniqueUploadFile = ({
  assetType,
  file,
  title,
  vehicleModelId,
  workstationId,
}: BuildUploadFileParams) => {
  const extension = getFileExtension(file.name);
  const fileSegments = [
    vehicleModelId ? `vehicle-${vehicleModelId}` : null,
    workstationId ? `ws-${workstationId}` : null,
    title ? sanitizeSegment(title) : null,
    assetType,
    buildTimestamp(),
  ].filter(Boolean);

  const nextName = `${fileSegments.join('_')}.${extension}`;

  return new File([file], nextName, {
    type: file.type,
    lastModified: file.lastModified,
  });
};
